module.exports = __webpack_public_path__ + "static/e-commerce-development-ed92e99b6b8ca1aee3faa0c750d0a27e.svg";